import { MentoringProgramEnrollment, MentoringProgramRole } from './mentoring-program-enrollments';
import { MentoringProgram } from './mentoring-programs';
import { MentorshipProgramRequest } from './mentorship-program-connections';

export const REQUEST_DATE_FORMAT = 'MMM D, h:mm A';

export enum SingleMentorRequestStatus {
  PENDING = 'pending',
  WITHDRAW = 'withdraw',
  APPROVED = 'approved',
  REJECTED = 'rejected',
  DROPPED = 'dropped',
}

export type CarouselArrowsType = {
  left: {
    show: boolean;
    onClick: () => void;
  };
  right: {
    show: boolean;
    onClick: () => void;
  };
};

export type MentorRequestParticipantType = MentoringProgramEnrollment & {
  availability?: number;
  isAvailable?: boolean;
};

export type UpdateRequestHandlerType = Promise<{
  payload: unknown;
  type: string;
}>;

export type MentorRequestContextType = {
  role?: MentoringProgramRole;
  source: MentorRequestSource;
  participant: MentorRequestParticipantType;
  aliases?: MentoringProgram['programAlias'];
  request: MentorshipProgramRequest;
  requests?: MentorshipProgramRequest[];
  sendRequest?: (data: any) => void;
  sendingRequest?: boolean;
  canDiscardChanges?: boolean;
  setCanDiscardChanges?: (canDiscard: boolean) => void;
  resetForm?: () => void;
  setResetForm?: (reset: () => void) => void;
  withdrawRequest?: () => UpdateRequestHandlerType;
  approveRequest?: () => UpdateRequestHandlerType;
  rejectRequest?: () => UpdateRequestHandlerType;
};

export enum MentorRequestSource {
  FIND_MENTOR = 1,
  MENTEE_HOME = 2,
  MENTOR_HOME = 3,
  TEAMS = 4,
  EMAIL = 5,
}

export type MentorRequestModalSettings = {
  source?: MentorRequestSource;
  showGoBack?: boolean;
  showCarousel?: boolean;
  hasLeftItems?: boolean;
  hasRightItems?: boolean;
  getPreviousMentorRequest?: () => void;
  getNextMentorRequest?: () => void;
  request?: MentorshipProgramRequest;
  requests?: MentorshipProgramRequest[];
  participant?: MentorRequestParticipantType;
};

export enum MentorRequestViewStatus {
  AVAILABLE = 'available',
  UNAVAILABLE = 'unavailable',
  PENDING_REQUEST = 'pending_request',
  PENDING_REQUEST_MENTOR_VIEW = 'pending_request_mentor_view',
}

export type MentorAvailableComponentProps = {};
export type MentorUnavailableComponentProps = {};
export type MentorPendingRequestComponentProps = {
  requests?: MentorshipProgramRequest[];
};
export type MentorPendingRequestMentorViewComponentProps = {};

export type MentorRequestComponentByStatus =
  | ((props: MentorAvailableComponentProps) => JSX.Element)
  | ((props: MentorUnavailableComponentProps) => JSX.Element)
  | ((props: MentorPendingRequestComponentProps) => JSX.Element)
  | ((props: MentorPendingRequestMentorViewComponentProps) => JSX.Element);

export const MENTOR_REQUESTS_PARAMS = [
  'source',
  'mentorRequest',
  'mentorId',
  'showProfile',
  'showLimitModal',
];
